import React from "react";

const Stripe = () => {
  // Handle Stripe

  return <>Unsuported as of now.</>;
};

export default Stripe;
